/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as RichtextFacet from '../../../app/bsky/richtext/facet.defs.js'

const $nsid = 'at.pylon.temp.game'

export { $nsid }

/** A record representing a video game. */
type Main = {
  $type: 'at.pylon.temp.game'
  name: string

  /**
   * The AT-URI of the at.pylon.temp.developer record.
   */
  developer: l.AtUriString

  /**
   * Flexible ordered blocks of content for the game page.
   */
  sections: (
    | l.$Typed<HeaderSection>
    | l.$Typed<TextSection>
    | l.$Typed<MediaSection>
    | l.Unknown$TypedObject
  )[]

  /**
   * Price in cents/smallest unit
   */
  priceAmount?: number
  priceCurrency?: string
  distribution?: DistributionLink[]
}

export type { Main }

/** A record representing a video game. */
const main = /*#__PURE__*/ l.record<'tid', Main>(
  'tid',
  $nsid,
  /*#__PURE__*/ l.object({
    name: /*#__PURE__*/ l.string({ maxLength: 200 }),
    developer: /*#__PURE__*/ l.string({ format: 'at-uri' }),
    sections: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<HeaderSection>((() => headerSection) as any),
          /*#__PURE__*/ l.typedRef<TextSection>((() => textSection) as any),
          /*#__PURE__*/ l.typedRef<MediaSection>((() => mediaSection) as any),
        ],
        false,
      ),
      { maxLength: 50 },
    ),
    priceAmount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
    priceCurrency: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.withDefault(
        /*#__PURE__*/ l.string({ maxLength: 3 }),
        'USD',
      ),
    ),
    distribution: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<DistributionLink>((() => distributionLink) as any),
      ),
    ),
  }),
)

export { main }

export const $isTypeOf = /*#__PURE__*/ main.isTypeOf.bind(main),
  $build = /*#__PURE__*/ main.build.bind(main),
  $type = /*#__PURE__*/ main.$type
export const $assert = /*#__PURE__*/ main.assert.bind(main),
  $check = /*#__PURE__*/ main.check.bind(main),
  $cast = /*#__PURE__*/ main.cast.bind(main),
  $ifMatches = /*#__PURE__*/ main.ifMatches.bind(main),
  $matches = /*#__PURE__*/ main.matches.bind(main),
  $parse = /*#__PURE__*/ main.parse.bind(main),
  $safeParse = /*#__PURE__*/ main.safeParse.bind(main),
  $validate = /*#__PURE__*/ main.validate.bind(main),
  $safeValidate = /*#__PURE__*/ main.safeValidate.bind(main)

type HeaderSection = {
  $type?: 'at.pylon.temp.game#headerSection'
  text: string
}

export type { HeaderSection }

const headerSection = /*#__PURE__*/ l.typedObject<HeaderSection>(
  $nsid,
  'headerSection',
  /*#__PURE__*/ l.object({ text: /*#__PURE__*/ l.string({ maxLength: 200 }) }),
)

export { headerSection }

type TextSection = {
  $type?: 'at.pylon.temp.game#textSection'
  text: string
  facets?: RichtextFacet.Main[]
}

export type { TextSection }

const textSection = /*#__PURE__*/ l.typedObject<TextSection>(
  $nsid,
  'textSection',
  /*#__PURE__*/ l.object({
    text: /*#__PURE__*/ l.string({ maxLength: 10000 }),
    facets: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<RichtextFacet.Main>(
          (() => RichtextFacet.main) as any,
        ),
      ),
    ),
  }),
)

export { textSection }

type MediaSection = {
  $type?: 'at.pylon.temp.game#mediaSection'
  assets: (l.$Typed<ImageItem> | l.$Typed<VideoItem> | l.Unknown$TypedObject)[]
}

export type { MediaSection }

const mediaSection = /*#__PURE__*/ l.typedObject<MediaSection>(
  $nsid,
  'mediaSection',
  /*#__PURE__*/ l.object({
    assets: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.typedUnion(
        [
          /*#__PURE__*/ l.typedRef<ImageItem>((() => imageItem) as any),
          /*#__PURE__*/ l.typedRef<VideoItem>((() => videoItem) as any),
        ],
        false,
      ),
    ),
  }),
)

export { mediaSection }

type ImageItem = {
  $type?: 'at.pylon.temp.game#imageItem'

  /**
   * The image data in one or more formats (AVIF, WebP, etc). Clients should choose the first supported format.
   */
  variants: l.BlobRef[]
  alt?: string
}

export type { ImageItem }

const imageItem = /*#__PURE__*/ l.typedObject<ImageItem>(
  $nsid,
  'imageItem',
  /*#__PURE__*/ l.object({
    variants: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.blob({
        accept: ['image/*'],
        maxSize: 1048576,
        allowLegacy: false,
      }),
      { minLength: 1, maxLength: 10 },
    ),
    alt: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 10000 })),
  }),
)

export { imageItem }

type VideoItem = {
  $type?: 'at.pylon.temp.game#videoItem'

  /**
   * The video data in one or more formats or resolutions. Clients should choose the first supported source.
   */
  variants: l.BlobRef[]
  alt?: string
}

export type { VideoItem }

const videoItem = /*#__PURE__*/ l.typedObject<VideoItem>(
  $nsid,
  'videoItem',
  /*#__PURE__*/ l.object({
    variants: /*#__PURE__*/ l.array(
      /*#__PURE__*/ l.blob({
        accept: ['video/*'],
        maxSize: 104857600,
        allowLegacy: false,
      }),
      { minLength: 1, maxLength: 10 },
    ),
    alt: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 10000 })),
  }),
)

export { videoItem }

type DistributionLink = {
  $type?: 'at.pylon.temp.game#distributionLink'
  label: string
  url: l.UriString
}

export type { DistributionLink }

const distributionLink = /*#__PURE__*/ l.typedObject<DistributionLink>(
  $nsid,
  'distributionLink',
  /*#__PURE__*/ l.object({
    label: /*#__PURE__*/ l.string({ maxLength: 50 }),
    url: /*#__PURE__*/ l.string({ format: 'uri', maxLength: 500 }),
  }),
)

export { distributionLink }
